import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';


@Component({
  selector: 'app-regulatory-analysis',
  template: `
    <router-outlet />
  `,
  imports: [
    RouterOutlet
  ]
})
export class RegulatoryAnalysisComponent {}{

}
